import Span, { SpanData } from "./Span";
import API from "./API";

export { Page, PageData, PageSpans };

type PageSpans = {
  /* Page Spans */
  spans: Span[];
  /** Page ID */
  pageId: string;
  /** Page Width in PX */
  width: number;
  /** Page Height in PX */
  height: number;
};
interface PageData {
  _spans?: PageSpans;
  externalPageIdentifier: string;
  pageIndex: number;
  width: number;
  height: number;
}
export default class Page implements PageData {
  _spans?: PageSpans = undefined;
  externalPageIdentifier: string = "";
  pageIndex: number = 0;
  spansLoadingPromise: Promise<PageSpans> | null = null;
  width: number = 0;
  height: number = 0;

  constructor(data?: PageData) {
    if (data) this.extend(data);
  }

  extend(data: PageData) {
    Object.assign(this, data);
    if (data._spans) {
      this._spans = {
        spans: data._spans.spans.map((x) => new Span(x)),
        pageId: this.externalPageIdentifier,
        height: this.height,
        width: this.width,
      };
    }
  }

  /**
   * Load Page spans and set correcvt batchUuid, docId, pageIndex properties.
   */
  getSpans(
    docId: string,
    batchUuid: string,
    pageIndex: number,
  ): Promise<PageSpans> {
    if (!this.spansLoadingPromise) {
      this.spansLoadingPromise = new Promise((res) => {
        if (this._spans) {
          return res(this._spans);
        }
        // get spans yo
        API.get("/v0/spans", {
          batchInstanceUuid: batchUuid,
          pageId: this.externalPageIdentifier,
        })
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            // spans failed to look up, return nothing
            res({
              pageId: this.externalPageIdentifier,
              spans: [],
              height: this.height,
              width: this.width,
            });
          })
          .then((resp: SpanData[]) => {
            const spans = resp.map((s) => new Span(s));
            spans.forEach((s) => {
              s.docId = docId;
              s.pageIndex = pageIndex;
            });
            this._spans = {
              pageId: this.externalPageIdentifier,
              spans,
              height: this.height,
              width: this.width,
            };
            res(this._spans);
          })
          .catch((e) => {
            console.warn(e);
            res({
              pageId: this.externalPageIdentifier,
              spans: [],
              height: this.height,
              width: this.width,
            });
          });
      });
    }
    return this.spansLoadingPromise;
  }

  static getRow(pageSpans: PageSpans, pRowNumber: number): Span[] {
    return pageSpans.spans.filter((span) => span.rowNumber === pRowNumber);
  }

  toData(): PageData {
    return {
      externalPageIdentifier: this.externalPageIdentifier,
      pageIndex: this.pageIndex,
      height: this.height,
      width: this.width,
    };
  }
}
